import React from 'react';

/**
 * The sentence naming who already holds a CRN, shared by the live check on
 * step 1 and the refusal on Review & Submit. The program to contact is the
 * request's own when it ranks one program, otherwise "the program".
 */
function CrnHolderNotice({ holder, crn, programKeys = [] }) {
    const program =
        programKeys.length === 1
            ? `the ${programKeys[0].toUpperCase()} program`
            : 'the program';
    return (
        <>
            {holder.name || 'Another faculty member'}
            {holder.email && (
                <>
                    {' ('}
                    <a href={`mailto:${holder.email}`}>{holder.email}</a>)
                </>
            )}{' '}
            already submitted a request for CRN {crn}
            {holder.sectionNumber && `, section ${holder.sectionNumber}`}
            {holder.instructorName && ` (instructor ${holder.instructorName})`},
            this term. Contact them to coordinate, or contact {program}.
        </>
    );
}

export default CrnHolderNotice;
